<template>
  <div>auth: <span id="auth">{{ currentUser !== null }}</span></div>
</template>

<script>
export default {
  name: 'WebviewAuth',

  computed: {
    currentUser () {
      return this.$store.state.currentUser.currentUser
    },

    locale () {
      return this.$route.params.locale
    },

    secret () {
      return process.env.WEBVIEW_SECRET
    },

    encrypted () {
      return atob(this.$route.params.token)
    },

    key () {
      return this.$store.state.webview.key
    },

    passphrase () {
      return this.key + this.secret
    },

    authToken () {
      const CryptoJS = require('crypto-js')

      let token = 'invalid'
      try {
        const bytes = CryptoJS.AES.decrypt(this.encrypted, this.passphrase)

        token = bytes.toString(CryptoJS.enc.Utf8)
      } catch (error) {
        console.log('error token', error)
      }

      return token
    }
  },

  created () {
    this.$store.dispatch('setAuthToken', this.authToken, { root: true })
    this.$locale.change(this.locale)
    this.$emit('loadingDone')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/webview/Auth.vue